import axios from 'axios'
// import NProgress from 'nprogress';
import router from "@/system_modules/router";
import { _G } from "./_common";


// axios.interceptors.request.use(req => {
//     // NProgress.start();
//     return req;
// }, (error) => {
//     // NProgress.done();
//     // if( error.response === undefined ){
//     //     return Promise.reject(error);
//     // }
//     return error;
// });

axios.interceptors.response.use(
    response => {
        // NProgress.done();
        if (response === undefined) {
            // _G.atoast.error('Server Connection Error !');
            return Promise.reject(response);
        }
        return response;
    }, (error) => {
        // NProgress.done();
        if (error.response === undefined) {
            // _G.atoast.error('Server Connection Error !');
            return Promise.reject(error);
        }
        else if (error.response.status == 0 && error.code == 'ERR_NETWORK') {
            // _G.atoast.error(`${error.message}`);
            return Promise.reject(error);
        }
        else if (error.response.status == 422 && error.code == 'ERR_BAD_REQUEST') {
            // _G.atoast.warn({ msg: _G.getErrorMessages(error.response.data.detail) });
            return Promise.reject(error);
        }
        else if (error.response.status == 408) {
            // _G.setClientData("AUTH_TOKEN", '');
            // _G.closeModalAll();
            router.push({ name: 'login', query: { redirect: window.location.pathname }, replace: true });
            // _G.atoast.error(error.response.data.detail);
            // router.go();
            return Promise.reject(error);
        }
        else
            return error;
    }
);

export const ajax = async (opt = null) => {
    if (opt != null && opt.url !== undefined && opt.url != ""){
        let aHeaders = {
            // "Content-Type": opt.contentType || "multipart/form-data",
            // "Authorization": this._TOKEN,
            // "X-Requested-With": "XMLHttpRequest",
            // "X-CSRF-TOKEN": document.getElementsByName('X-CSRF-TOKEN')[0].content,
            // 'Access-Control-Allow-Origin': '*',
            // "Accept": 'application/json',
            'Content-Type': opt && opt.content_type ? opt.content_type : 'application/x-www-form-urlencoded',
            // "Authorization": opt && opt.token ? `Bearer ${opt.token}` : _G.getClientData("AUTH_TOKEN"),
        };
        Object.keys(_G.ajaxHeaders).forEach((k) => {
            aHeaders[k] = (typeof _G.ajaxHeaders[k] === 'function' ) ? _G.ajaxHeaders[k]() : _G.ajaxHeaders[k];
        });

        await axios({
            // baseURI parameter defined on user side when call ajax function.
            baseURL: opt && opt.baseURI !== undefined && opt.baseURI != '' ? _G.ajaxBaseUrl[opt.baseURI] : _G.ajaxBaseUrl['default'],
            url: opt.url,
            method: opt.method || "get",
            data: opt.data || {},
            // crossDomain: true,
            responseType: opt.responseType ? opt.responseType : null,
            headers: opt.header || aHeaders,
            // timeout: 3000,
            // config: {
            //     headers: {
            //         // 'Content-Type': 'multipart/form-data',
            //         "Access-Control-Allow-Origin": "http://localhost:8080",
            //     }
            // },
            withCredentials: false,
            // credentials: 'same-origin',
            // crossDomain: true,
        }).then(async (response) => {
            // if (response.data && response.data.token && response.data.token != "") {
            //     this._TOKEN = response.data.token;
            // }
            if ( response.status == 200 ){
                if (opt.success !== undefined && opt.success != null){
                    await opt.success(response);
                }
            }
            else{
                if (opt.error !== undefined && opt.error != null){
                    await opt.error(response);
                }
                else if( response.response != undefined && response.response.status != 200 ){
                    // _G.atoast.error({msg: response.response.data.detail});
                }
                else{
                    // _G.atoast.error({msg: response.data.detail});
                }
            }
        }).catch(async (error) => {
            let resp = error.response;
            if (opt.error !== undefined && opt.error != null && resp !== undefined){
                await opt.error(error);
            }
            else if (resp && resp.data){
                // _G.atoast.error({msg: _G.getErrorMessages(resp.data.detail)});
            }
        });
    }
};
